import { render, staticRenderFns } from "./ComboCard.vue?vue&type=template&id=43331807&lang=pug"
import script from "./ComboCard.vue?vue&type=script&lang=js"
export * from "./ComboCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports